module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/6-eb8725a56400293fd1535224fd62748a.jpg";